export default __webpack_public_path__ + "static/media/video-bg.28918221.webp";